import { X } from "react-feather";
import styles from "../tour.module.css";
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const EventViewPopup = (props) => {
  const { user, isAuthenticated } = useAuth0();

  return (<>
    <DialogTitle id="alert-dialog-title">
      Event
      <button onClick={(e) => props.setViewEventOpen2(false)}><X /></button>
    </DialogTitle>

    <DialogContent>
      <DialogContentText>
        <div className={`${styles.CalendarEditPopup}`}>
          <ul>
            <li>
              <p className={`${styles.CalendarEditPopupTitle}`}>Title:</p>
              <p className={`${styles.CalendarEditPopupCon}`}>{props?.selectedEvent?.title}</p>
            </li>
            <li>
              <p className={`${styles.CalendarEditPopupTitle}`}>Property:</p>
              <Link className={`${styles.CalendarEditPopupCon}`} to={"/properties/details/" + props?.selectedEvent?.extendedProps?.property_id}>{props?.selectedEvent?.extendedProps?.property_name}</Link>
            </li>
            <li>
              <p className={`${styles.CalendarEditPopupTitle}`}>Date:</p>
              <p className={`${styles.CalendarEditPopupCon}`}>{dayjs(props?.selectedEvent?.extendedProps?.date_time).format("MM/DD/YYYY hh:mmA")}</p>
            </li>
          </ul>
        </div>
      </DialogContentText>
    </DialogContent>

    {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("event:update") > -1 || user["https://propertydek.com/permissions"].indexOf("event:delete") > -1) && <DialogActions>
      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("event:delete") > -1 && <Button className="CancelPopupBU" onClick={(e) => { props.setViewEventOpen2(false); props.setOpenDeleteModal(true); }}>Delete</Button>}
      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("event:update") > -1 && <Button className="SubmitPopupBU" onClick={(e) => { props.setViewEventOpen2(false); props.setEditEventOpen(true); }}>Update</Button>}
    </DialogActions>}
  </>);
};

export default EventViewPopup;
